module.exports = __webpack_public_path__ + "static/the_fish1-ca724098970f3f7fc45cb94ce10e5b21.mp4";